import {selectArr} from "../utils/utils";
import Swiper from 'swiper/bundle';

export class HeroCarousel {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
  }

  props() {
    this.carouselContainer = selectArr("[data-hero-carousel]");
  }

  render() {
    this.statsCarousel();
  }

  statsCarousel = () => {
      this.carouselContainer.map(cc => {
          new Swiper(cc, {
              slidesPerView: 1,
              spaceBetween: 0,
              loop: true,
              autoplay: {
                  delay: 8000,
              },
              centeredSlides: true,
              pagination: {
                  el: '[data-hero-carousel] .swiper-pagination',
                  type: 'bullets',
                  clickable: true
              },
          });
      })
  };
}
